<template>
    <div v-if="product">
        <div class="card product border-0">
            <div class="product-image" v-bind:class="{ 'product-image-contain':product.subproduct_id }" v-bind:style="{ 'background-image': (product.thumbnail ? 'url('+product.thumbnail+')' : '') }">
                <div v-if="product.is_new" class="product-badge">{{ __('redeem.new') }}</div>
                <img
                    v-if="listIcon"
                    :src="listIcon.url"
                    :title="listIcon.text"
                    style="max-width: 55px; position: absolute; bottom: 5px; left: 5px;"
                    :style="{ left: (['miljo_bsci', 'miljo_oeko-tex'].includes(listIcon.name) ? '5px' : '-10px') }"
                >
            </div>
            <div class="card-body">
                <div class="product-info">
                    <h6 class="product-header"><span v-if="cart_item_qty > 1">{{cart_item_qty}} x </span>{{ product.title }}</h6>
                    <p class="product-subheader" v-if="sub_products.length === 0">{{ product.sub_title }}</p>
                    <p class="product-subheader" v-if="sub_products.length > 0">{{ getSubproductTitles() }}</p>
                    <p v-if="points" class="product-price"><span v-if="cart_item_qty > 1">{{cart_item_qty}} x </span>{{ product.points }} {{ __('redeem.points') }}</p>
                    <p v-else-if="order" class="product-price"><span v-if="cart_item_qty > 1">{{cart_item_qty}} x </span>{{ product.price }} kr</p>
                    <div class="stock-status" v-if="!hide_stock">
                        <p v-if="product.phased_out" class="product-subheader" style="color: #e0ac13;">{{ __('redeem.product_is_phased_out') }}</p>
                        <p v-else-if="product.out_of_stock && product.block_purchase_until_date" class="product-subheader" style="color: #e0ac13;">{{ __('redeem.stock_status_out_of_stock') }} {{ product.block_purchase_until_date }}</p>
                        <p v-else-if="product.out_of_stock" class="product-subheader" style="color: #e0ac13;">{{ __('redeem.out_of_stock') }}</p>
                        <p v-else-if="product.is_non_stock_item" class="product-subheader" style="color: #27a227;">{{ __('redeem.16_days') }}</p>
                        <p v-else class="product-subheader" style="color: #27a227;">{{ __('redeem.stock_status_in_stock') }}</p>
                    </div>
                </div>
                <div>
                    <button v-if="!hide_buttons && !hide_info" type="button" class="btn btn-light btn-block btn-lg btn-info" @click="openModal" :id="'modallabel-product-'+getProductID()">{{ __('redeem.info') }}</button>
                    <div v-if="!hide_select && !hide_buttons && order">
                        <form v-if="selected" :action="'/'+__('redeem.current_langcode')+'/order/update'" method="POST">
                            <input type="hidden" name="_token" :value="csrf">
                            <input type="hidden" name="remove_item_id" :value="(cart_item_id ? cart_item_id : getProductID())">
                            <input v-if="product.subproduct_id" type="hidden" name="remove_subproduct_id" :value="product.subproduct_id">
                            <input type="number" min="0" step="1" class="form-control mb-2" v-model="quantity">
                            <button type="submit" class="btn btn-primary btn-block btn-lg">{{ __('redeem.remove') }}</button>
                        </form>
                        <form v-else :action="'/'+__('redeem.current_langcode')+'/order/update'" method="POST">
                            <input type="hidden" name="_token" :value="csrf">
                            <input type="hidden" name="item_id" :value="(cart_item_id ? cart_item_id : getProductID())">
                            <input v-if="product.subproduct_id" type="hidden" name="media_item_id" :value="product.subproduct_id">
                            <button type="submit" class="btn btn-primary btn-block btn-lg">{{ __('redeem.buy') }}</button>
                        </form>
                    </div>
                    <div v-else-if="!hide_select && !hide_buttons">
                        <form :action="'/'+__('redeem.current_langcode')+'/redeem/update'" method="POST" ref="selectform">
                            <input type="hidden" name="_token" :value="csrf">

                            <div v-if="selected">
                                <input type="hidden" name="remove_item_id" :value="(cart_item_id ? cart_item_id : getProductID())">
                                <input v-if="product.subproduct_id && product.type === 'pocket_pack' && selected" type="hidden" name="remove_subproduct_id" :value="product.subproduct_id">
                            </div>
                            <div v-else>
                                <input type="hidden" name="item_id" :value="(cart_item_id ? cart_item_id : getProductID())">
                                <input v-if="product.subproduct_id" type="hidden" name="media_item_id" :value="product.subproduct_id">
                            </div>

                            <div class="submit-button">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="chooseDisabled">{{ chooseText }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade product-modal" :id="'modal-product-'+getProductID()+(product.subproduct_id ? '-'+product.subproduct_id : '')" tabindex="-1" role="dialog" :aria-labelledby="'modallabel-product-'+getProductID()" aria-hidden="true">
            <div
                class="modal-dialog"
                v-bind:class="{
                    'modal-xl':(type!=='pocket_pack' && type!=='magazine_subscription'),
                    'modal-lg':(type==='pocket_pack' || type==='magazine_subscription'),
                }"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <div>
                            <h2 class="modal-title">{{ product.title }}</h2>
                            <h5 class="modal-subtitle">{{ product.sub_title }}</h5>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="__('redeem.close')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div v-if="type==='pocket_pack' || type==='magazine_subscription'" class="modal-body">
                        <div v-if="product.thumbnail" style="float: right; margin: 0 0 0 20px;">
                            <img alt="" :src="product.thumbnail" style="width: 170px;"><br>
                        </div>
                        <div>
                            <span v-if="product.author"><i>{{ __('redeem.author') }}: {{ product.author }}</i><br></span>
                            <span v-if="product.subscription"><i>{{ __('redeem.author') }}: {{ product.subscription }}</i><br></span>
<!--                            <span v-if="product.next_edition"><i>{{ __('redeem.next_edition') }}: {{ product.next_edition }}</i><br></span>-->
                            <span v-if="product.publisher"><i>{{ __('redeem.publisher') }}: {{ product.publisher }}</i><br></span>
                            <span v-if="product.publish_date"><i>{{ __('redeem.publish_date') }}: {{ product.publish_date }}</i><br></span>
                            <span v-if="product.genre"><i>{{ __('redeem.genre') }}: {{ product.genre }}</i><br></span>
                            <span v-if="product.isbn"><i>{{ __('redeem.isbn') }}: {{ product.isbn }}</i><br></span>
                            <span v-else-if="product.type==='pocket_pack'"><i>{{ __('redeem.format') }}: {{ __('redeem.pocket') }}</i><br></span>
                            <span v-if="product.no_of_issues"><i>{{ __('redeem.subscription_includes') }} {{ product.no_of_issues }} {{ __('redeem.numbers') }}</i><br></span>
                            <div style="margin-top: 10px;" v-html="product.description"></div>
                        </div>
                    </div>
                    <div v-else class="modal-body">
                        <div class="row">
                            <div class="col-12 col-md-6 order-2 order-md-1 mb-4">
                                <div v-html="product.description"></div>
                                <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                                    <img v-for="(icon, icon_index) in product.icons" :src="icon.url" :title="icon.text" style="max-width: 65px;" :key="'icon-' + icon_index">
                                </div>
                                <div
                                    v-if="!chooseDisabled && !hide_select && !hide_buttons && !selected"
                                    class="submit-button"
                                >
                                    <button
                                        type="button"
                                        @click="() => { if ($refs['selectform']) { $refs['selectform'].submit(); } }"
                                        class="btn btn-primary btn-block btn-lg mt-4"
                                    >{{ __('redeem.choose_this_gift') }}</button>
                                </div>
                                <hr>
                                <h5 class="styled-header">{{ __('redeem.delivery_information') }}</h5>
                                <div v-if="product.product_category_id===102" class="mt-4">
                                    <p v-html="__('redeem.delivery_info.charity')"></p>
                                </div>
                                <div v-else-if="product.is_food==1">
                                    <img alt="" src='/_images/kylbox.jpg' style='height:92px; margin-top:10px;'>
                                    <p v-html="__('redeem.delivery_info.food')"></p>
                                </div>
                                <div v-else-if="product.is_virtual==1 || (product.allowed_deliv_types & 4) === 4">
                                    <p v-html="__('redeem.delivery_info.online')"></p>
                                </div>
                                <div v-else-if="product.allowed_deliv_types==='' || product.allowed_deliv_types===1" class="mt-4">
<!--                                    <img alt="" src='/_images/leverans_box.jpg' style='height:92px;'>-->
                                    <p v-html="__('redeem.delivery_info.dpd')"></p>
                                </div>
                                <div v-else-if="(product.allowed_deliv_types & 2) === 2" class="mt-4">
<!--                                    <img alt="" src='/_images/leverans_box.jpg' style='height:92px;'>-->
                                    <p v-html="__('redeem.delivery_info.postoffice')"></p>
                                </div>
                                <div v-if="(product.allowed_deliv_types & 8) === 8" v>
                                    <p v-html="__('redeem.delivery_info.postal')"></p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 order-1 order-md-2 mb-4">
                                <div v-if="product.images.length">
                                    <div :id="'image-carousel-'+getProductID()" class="carousel slide" data-ride="carousel">
                                        <ol class="carousel-indicators">
                                            <li v-for="(image, i_index) in product.images" :key="i_index" :data-target="'#image-carousel-'+getProductID()" :data-slide-to="i_index" v-bind:class="{ 'active': i_index<1 }"></li>
                                        </ol>
                                        <div class="carousel-inner">
                                            <div v-for="(image, i_index) in product.images" :key="i_index" class="carousel-item" v-bind:class="{ 'active': i_index<1 }">
                                                <img class="d-block w-100" :src="image" :alt="product.title">
                                            </div>
                                        </div>
                                        <a class="carousel-control-prev" :href="'#image-carousel-'+getProductID()" role="button" data-slide="prev">
                                            <div style="background-color: black; display: inline-block; border-radius: 3px; padding: 12px 7px 7px 7px;">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Previous</span>
                                            </div>
                                        </a>
                                        <a class="carousel-control-next" :href="'#image-carousel-'+getProductID()" role="button" data-slide="next">
                                            <div style="background-color: black; display: inline-block; border-radius: 3px; padding: 12px 7px 7px 7px;">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Next</span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            default() {
                return {};
            },
        },
        sub_products: {
            type: Array,
            default() {
                return [];
            },
        },
        prod_id: {
            type: Number,
            default: null,
        },
        is_locked: {
            type: Number,
            default: 0,
        },
        type: {
            type: String,
            default: 'product',
        },
        testmode: {
            type: String,
            default: null,
        },
        cart_item_id: {
            type: String,
            default: null,
        },
        cart_item_qty: {
            type: Number,
            default: null,
        },
        points: {
            type: Boolean,
            default: false,
        },
        pointsLeft: {
            type: Number,
            default: 0,
        },
        order: {
            type: Boolean,
            default: false,
        },
        quantity: {
            type: Number,
            default: 1,
        },
        hide_buttons: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        is_out_of_stock: {
            type: Boolean,
            default: false,
        },
        mediaSelect: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }),
    methods: {
        openModal() {
            $('#modal-product-' + this.getProductID() + (this.product.subproduct_id ? '-' + this.product.subproduct_id : '')).modal('show');
        },
        getProductID() {
            return this.product.id ? this.product.id : this.prod_id;
        },
        getSubproductTitles() {
            const titles = [];

            this.sub_products.forEach((product) => {
                titles.push(product.title);
            });

            return titles.join(', ');
        },
        isRedeemed() {
            return !!this.order;
        },
    },
    computed: {
        hide_stock() {
            // if (this.product.product_category_id === 1) {
            //     return false;
            // }

            // if (this.product.is_virtual) {
            //     return false;
            // }

            return this.type === 'pocket_pack'
                || this.type === 'magazine_subscription'
                || this.type === 'sfanytime_codes'
                || this.testmode === 'PRO'
                || this.testmode === 'TOT';
        },
        listIcon() {
            if (this.product && this.product.icons) {
                const miljoIcons = this.product.icons.filter((ico) => ico.category === 'Miljö');
                if (miljoIcons[0]) {
                    return miljoIcons[0];
                }
            }
            return null;
        },
        chooseText() {
            if (this.is_locked) {
                return this.__('redeem.locked_product');
            }
            if (this.selected) {
                return this.__('redeem.change_product');
            }
            if (this.testmode === 'TOT') {
                return this.__('redeem.choose');
            }
            if (this.product.phased_out) {
                return this.__('redeem.is_phased_out');
            }
            if (this.product.out_of_stock && (this.product.back_in_stock_date === null)) {
                return this.__('redeem.incoming');
            }
            return this.__('redeem.choose');
        },
        chooseDisabled() {
            if (this.is_locked) {
                return true;
            }
            if (this.selected) {
                return false;
            }
            if (this.product.phased_out) {
                return true;
            }
            if (this.points && !(this.pointsLeft >= this.product.points)) {
                return true;
            }
            if (this.testmode === 'TOT') {
                return false;
            }
            if (this.testmode === 'PRO') {
                return true;
            }
            if (this.product.out_of_stock && (this.product.back_in_stock_date === null)) {
                return true;
            }
            return false;
        },
        hide_select() {
            return this.type === 'sfanytime_codes'
                || this.testmode === 'PRO'
                || ((this.type === 'pocket_pack' || this.type === 'magazine_subscription') && !this.mediaSelect);
        },
        hide_info() {
            return this.type === 'pocket_pack'
                || this.type === 'magazine_subscription'
                || this.type === 'sfanytime_codes';
        },
    },
};
</script>
